export const navItems = [
  { to: '/highlights', label: 'Highlights' },
  { to: '/projects', label: 'Projects' },
  { to: '/challenge', label: '30 Day Map Challenge' },
  { to: '/coding', label: 'Coding Projects' },
  { to: '/webgis', label: 'Web GIS Experience' },
];
